module.exports = __webpack_public_path__ + "img/upload_big_txt.adfd8817.png";